/**
 * Texto que acompaña al MP3 al compartir (paciente + fecha de estudio).
 */

/**
 * @param {string} [raw]
 * @returns {string}
 */
export function formatStudyDateForShare(raw) {
  if (raw == null) return ''
  const s = String(raw).trim()
  if (!s) return ''
  // DICOM DA YYYYMMDD
  if (/^\d{8}$/.test(s)) {
    try {
      const iso = `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
      const d = new Date(iso)
      if (!Number.isNaN(d.getTime())) {
        return d.toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        })
      }
    } catch (e) {
      /* fall through */
    }
    return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
  }
  // "YYYYMMDD.HHMMSS" u otros compuestos → primera parte
  const head = s.split(/[.\sT]/)[0]
  if (/^\d{8}$/.test(head)) return formatStudyDateForShare(head)
  return s
}

/**
 * @param {{
 *   patientName?: string,
 *   patientId?: string,
 *   studyDate?: string,
 *   studyDescription?: string,
 *   modality?: string,
 *   noteName?: string,
 *   createdAt?: number,
 *   studyUrl?: string,
 *   transcriptText?: string,
 *   transcript?: { text?: string },
 * }} meta
 * @returns {string}
 */
export function buildVoiceNoteShareText(meta) {
  const m = meta || {}
  const lines = ['Nota médica UDV']
  const patientName = m.patientName != null ? String(m.patientName).trim() : ''
  const patientId = m.patientId != null ? String(m.patientId).trim() : ''
  const studyDate = formatStudyDateForShare(m.studyDate)
  const studyDescription =
    m.studyDescription != null ? String(m.studyDescription).trim() : ''
  const modality = m.modality != null ? String(m.modality).trim() : ''
  const noteName = m.noteName != null ? String(m.noteName).trim() : ''

  if (patientName) lines.push(`Paciente: ${patientName}`)
  if (patientId) lines.push(`ID paciente: ${patientId}`)
  if (studyDate) lines.push(`Fecha de estudio: ${studyDate}`)
  if (studyDescription) lines.push(`Estudio: ${studyDescription}`)
  if (modality) lines.push(`Modalidad: ${modality}`)
  if (noteName) lines.push(`Archivo: ${noteName}`)
  if (m.createdAt) {
    try {
      const when = new Date(m.createdAt)
      if (!Number.isNaN(when.getTime())) {
        lines.push(`Nota creada: ${when.toLocaleString()}`)
      }
    } catch (e) {
      /* ignore */
    }
  }
  const transcript =
    m.transcriptText != null
      ? String(m.transcriptText).trim()
      : m.transcript && m.transcript.text
        ? String(m.transcript.text).trim()
        : ''
  if (transcript) {
    lines.push('')
    lines.push('Transcripción:')
    lines.push(transcript)
  }
  const studyUrl = m.studyUrl != null ? String(m.studyUrl).trim() : ''
  if (studyUrl) {
    lines.push('')
    lines.push(studyUrl)
  }
  return lines.join('\n')
}

export default buildVoiceNoteShareText
